import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuDispatchSlottingView } from "src/tenantCustomizations/tenants/mellano/views/luukku/slotting/MellanoLuukkuDispatchSlottingView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/dispatchSlotting")({
	staticData: { title: "Lähetyksen ruudutus", legacyViewKey: "mellanoLuukkuDispatchSlottingView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuDispatchSlottingView />;
}
